// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"progressBar__gradient-bg5__GwzRO","progressBar":"progressBar__progressBar__xIQtt"};